import { SchemaState } from './schema.reducer';
import { createSelector, createFeatureSelector } from '@ngrx/store';

export const getSchemaState = createFeatureSelector<SchemaState>('schema');

export const getSchemaProjects = createSelector(
  getSchemaState,
  (state: SchemaState) => state.projects,
);

export const getSchemaDefinitions = createSelector(
  getSchemaState,
  (state: SchemaState) => state.definitions,
);

export const getSchemaDefinitionVersions = createSelector(
  getSchemaState,
  (state: SchemaState) => state.definitionVersions,
);

export const getLatestSchemaDefinitionVersion = createSelector(
  getSchemaState,
  (state: SchemaState) =>
    state.definitionVersions && state.definitionVersions.length > 0 && state.definitionVersions[0],
);

export const getSchemaDefinition = createSelector(
  getSchemaState,
  (state: SchemaState) => state.definition,
);

export const getSchemaDefinitionName = createSelector(getSchemaState, (state: SchemaState) => {
  if (state.definition) {
    return state.definition.name;
  }
  if (state.definitionVersions.length > 0) {
    return state.definitionVersions[0].name;
  }
  return '';
});

export const getCurrentSchemaProject = createSelector(
  getSchemaState,
  (state: SchemaState) => state.currentProject,
);

export const getCurrentSchemaProjectName = createSelector(
  getSchemaState,
  (state: SchemaState) => state.currentProject && state.currentProject.name,
);

export const getCurrentSchemas = createSelector(
  getSchemaState,
  (state: SchemaState) => state.currentSchemas,
);

export const getCurrentSchema = createSelector(
  getSchemaState,
  (state: SchemaState) => state.currentSchema,
);

export const getCurrentSchemaValues = createSelector(
  getSchemaState,
  (state: SchemaState) => state.currentSchema && state.currentSchema.values,
);

export const getActiveSchema = createSelector(
  getSchemaState,
  (state: SchemaState) => state.activeSchema,
);

export const getSchemaError = createSelector(
  getSchemaState,
  (state: SchemaState) => state.apiError,
);
